__turbopack_context__.v({
  "acheivername": "psy-optional-module__HaHOlG__acheivername",
  "acheivername1": "psy-optional-module__HaHOlG__acheivername1",
  "acheiverrank": "psy-optional-module__HaHOlG__acheiverrank",
  "acheiverrank1": "psy-optional-module__HaHOlG__acheiverrank1",
  "acheiverrank2": "psy-optional-module__HaHOlG__acheiverrank2",
  "acheiverrank3": "psy-optional-module__HaHOlG__acheiverrank3",
  "acheiverrank4": "psy-optional-module__HaHOlG__acheiverrank4",
  "acheivertitle": "psy-optional-module__HaHOlG__acheivertitle",
  "ansheet": "psy-optional-module__HaHOlG__ansheet",
  "bgboxbg": "psy-optional-module__HaHOlG__bgboxbg",
  "captcha": "psy-optional-module__HaHOlG__captcha",
  "checkboxcontent": "psy-optional-module__HaHOlG__checkboxcontent",
  "classesborder": "psy-optional-module__HaHOlG__classesborder",
  "contactbox": "psy-optional-module__HaHOlG__contactbox",
  "contactboxheight": "psy-optional-module__HaHOlG__contactboxheight",
  "contactsubcontent": "psy-optional-module__HaHOlG__contactsubcontent",
  "gshad": "psy-optional-module__HaHOlG__gshad",
  "img": "psy-optional-module__HaHOlG__img",
  "imgboxbelow": "psy-optional-module__HaHOlG__imgboxbelow",
  "invalidCheck2": "psy-optional-module__HaHOlG__invalidCheck2",
  "mainshead": "psy-optional-module__HaHOlG__mainshead",
  "mbtableheading": "psy-optional-module__HaHOlG__mbtableheading",
  "medalicon": "psy-optional-module__HaHOlG__medalicon",
  "mobhead": "psy-optional-module__HaHOlG__mobhead",
  "mobilemaillinks": "psy-optional-module__HaHOlG__mobilemaillinks",
  "more": "psy-optional-module__HaHOlG__more",
  "normalbutton": "psy-optional-module__HaHOlG__normalbutton",
  "normalbutton2": "psy-optional-module__HaHOlG__normalbutton2",
  "pagemaintitle": "psy-optional-module__HaHOlG__pagemaintitle",
  "paybill": "psy-optional-module__HaHOlG__paybill",
  "paybills": "psy-optional-module__HaHOlG__paybills",
  "redunderline": "psy-optional-module__HaHOlG__redunderline",
  "sectiontitle": "psy-optional-module__HaHOlG__sectiontitle",
  "sectiontitle1": "psy-optional-module__HaHOlG__sectiontitle1",
  "sectiontitle2": "psy-optional-module__HaHOlG__sectiontitle2",
  "subhead": "psy-optional-module__HaHOlG__subhead",
  "tableheading": "psy-optional-module__HaHOlG__tableheading",
  "tablepara": "psy-optional-module__HaHOlG__tablepara",
  "tablepara1": "psy-optional-module__HaHOlG__tablepara1",
  "tablescroll": "psy-optional-module__HaHOlG__tablescroll",
  "toppersupsc": "psy-optional-module__HaHOlG__toppersupsc",
  "viewbutton": "psy-optional-module__HaHOlG__viewbutton",
});
